/* @flow */

import { combineReducers } from 'redux';

import liveChatReducer from 'plugin/live-chat/reducer/liveChatReducer';

export default combineReducers({
  liveChat: liveChatReducer,
});
